export default "__VITE_ASSET__DIRWXZ13__"